import { render } from "./CommunityTable.vue?vue&type=template&id=17ef6d2c&scoped=true"
import script from "./CommunityTable.vue?vue&type=script&lang=js"
export * from "./CommunityTable.vue?vue&type=script&lang=js"

import "./CommunityTable.vue?vue&type=style&index=0&id=17ef6d2c&scoped=true&lang=css"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ef6d2c"]])

export default __exports__